<template>
  <v-card>
    <v-form ref="form" :lazy-validation="true">
      <v-card-title>MKF Handledarutbildning</v-card-title>
      <v-card-actions>
        <v-icon class="close" @click="$emit('close')">$sl-close</v-icon>
      </v-card-actions>

      <v-card-text class="mt-n6" v-if="modalMode === 'edit'">
        <v-row>
          <v-col cols="12" md="6">
            <p class="text-uppercase overline">Datum tillagd</p>
            <p class="mt-n3">
              {{ dcData.issuedOn | date }}
            </p>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="mt-n6" v-if="modalMode === 'create'">
        <v-row>
          <v-col cols="12" md="6">
            <DatePicker
              placeholder="ÅÅÅÅ-MM-DD"
              :icon="'$sl-calendar-date'"
              label="Datum tillagd"
              outlined
              v-model="dcData.issuedOn"
              ref="datePicker"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-end mt-n6">
        <v-btn color="secondary" @click="$emit('close')"> <v-icon>$sl-cancel</v-icon>Avbryt </v-btn>
        <v-btn :disabled="modalMode !== 'edit' || !canDelete" color="secondary"  @click="emitDeleteData"> <v-icon>$sl-delete</v-icon>Radera </v-btn>
        <v-btn :disabled="modalMode !== 'create' || !canCreate" @click="emitSaveData"> <v-icon>$sl-check</v-icon>Spara </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import DatePicker from '@/components/common/DatePicker'
import {Regions, RulesMixin, CanIDo} from '@/components/mixins'
// @group Person
// PersonMachineQualificationModal component
export default {
  name: 'Modal',

  mixins: [Regions, RulesMixin, CanIDo],

  components: {
    DatePicker
  },

  data: () => ({
    dcData: {}
  }),

  props: {
    diverseQualification: Object,
    modalMode: String,
    showModal: Boolean
  },

  watch: {
    'showModal' :{
      handler(newVal, oldVal) {
        if (newVal) {
          this.dcData = Object.assign({issuedOn: this.$options.filters.date(new Date()), diverseQualificationType: 'mkfInstructions'}, this.diverseQualification)
        }
      },
      immediate: true
    },
  },

  asyncComputed: {
    canDelete(){
      return this.canIDo('person-qualification', 'delete');
    },
    canCreate(){
      return this.canIDo('person-qualification', 'create');
    },
  },

  computed: {
    ...mapGetters('person', ['selectedPerson']),
    ...mapGetters('currentuser', ['currentUser', 'currentUserRole'])
  },

  methods: {
    emitSaveData() {
      if (!this.$refs.form.validate() || !this.$refs.datePicker.$refs.form.validate()) {
        this.$events.fire('showError', 'Formuläret är inte korrekt ifyllt.')
        return
      }
      this.$emit('create', this.dcData)
    },

    emitDeleteData() {
      this.$emit('delete', this.dcData)
    }
  }
}
</script>

<style>
</style>
